import { DEAL_GROUPING_TYPE } from './DealGroupingType';
import { CRMSearchSortValue, SortIntegerValues } from './SortValues';
export const CRM_SEARCH_DELAY = 5000;
export const DEAL_OBJECT_ID = '0-3';
export const DEAL_SPLIT_OBJECT_ID = '0-72';

// Used for deal requests
export const TABLE_DEFAULT_PAGE_SIZE = 25;
export const TABLE_DEFAULT_PAGE_NUM = -1; // should default to -1 (which means we don't know how many pages we have)

export const DEAL_PROPERTIES = {
  FORECAST_CATEGORY: 'hs_manual_forecast_category',
  DEAL_STAGE: 'dealstage',
  OWNER_ID: 'hubspot_owner_id',
  AMOUNT: 'amount',
  STAGE: 'dealstage',
  LAST_UPDATED: 'notes_last_updated',
  AMOUNT_IN_HOME_CURRENCY: 'amount_in_home_currency',
  CLOSE_DATE: 'closedate',
  FORECAST_AMOUNT: 'hs_forecast_amount',
  NUM_DEAL_SPLITS: 'hs_num_associated_deal_splits',
  DEAL_NAME: 'dealname',
  DEAL_SCORE: 'hs_deal_score',
  WEIGHTED_AMOUNT: 'hs_projected_amount',
  WEIGHTED_AMOUNT_IN_HOME_CURRENCY: 'hs_projected_amount_in_home_currency',
  FORECASTED: 'hs_forecasted',
  IS_CLOSED_WON: 'hs_is_closed_won'
};
export const SEARCH_OPERATORS = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  IN: 'IN',
  HAS_PROPERTY: 'HAS_PROPERTY',
  BETWEEN: 'BETWEEN',
  ROLLING_DATE_RANGE: 'ROLLING_DATE_RANGE'
};
export const defaultDealSearchOptions = dealGroupingType => ({
  page: 0,
  pageSize: TABLE_DEFAULT_PAGE_SIZE,
  sorts: [{
    property: DEAL_PROPERTIES.IS_CLOSED_WON,
    order: CRMSearchSortValue.ASCENDING
  }, {
    property: DEAL_GROUPING_TYPE[dealGroupingType].propertyName,
    order: CRMSearchSortValue.DESCENDING
  }]
});
export const DEFAULT_SORT_STATE = {
  columnName: 'dealname',
  columnNamespace: DEAL_OBJECT_ID,
  direction: SortIntegerValues.ASCENDING
};
export const DEFAULT_PAGINATION_STATE = {
  pageIndex: 0,
  pageSize: 25
};
export const DEAL_SPLIT_PROPERTIES = {
  HS_DEAL_ID: 'hs_deal_id',
  HS_DEAL_SPLIT_FORECAST_AMOUNT: 'hs_deal_split_forecast_amount',
  HS_DEAL_SPLIT_AMOUNT_IN_HOME_CURRENCY: 'hs_deal_split_amount_in_home_currency',
  HS_OWNER_ID: 'hubspot_owner_id',
  HS_DEAL_SPLIT_AMOUNT: 'hs_deal_split_amount',
  HS_DEAL_SPLIT_PERCENTAGE: 'hs_deal_split_percentage',
  HS_DEAL_CLOSE_DATE: 'hs_deal_close_date',
  HS_DEAL_PIPELINE_ID: 'hs_deal_pipeline_id'
};
export const DEFAULT_DEAL_SPLIT_PROPERTIES = [DEAL_SPLIT_PROPERTIES.HS_DEAL_ID, DEAL_SPLIT_PROPERTIES.HS_DEAL_SPLIT_FORECAST_AMOUNT, DEAL_SPLIT_PROPERTIES.HS_DEAL_SPLIT_AMOUNT_IN_HOME_CURRENCY, DEAL_SPLIT_PROPERTIES.HS_OWNER_ID, DEAL_SPLIT_PROPERTIES.HS_DEAL_SPLIT_AMOUNT, DEAL_SPLIT_PROPERTIES.HS_DEAL_SPLIT_PERCENTAGE, DEAL_SPLIT_PROPERTIES.HS_DEAL_CLOSE_DATE, DEAL_SPLIT_PROPERTIES.HS_DEAL_PIPELINE_ID];

// Synchronized with crm-index-ui/static/js/rewrite/pipelines/constants/AllPipelinesValue.ts
export const ALL_PIPELINES_QUERY_PARAM = 'all';